// Map Asset Library — top-down ("bird's eye view") sprites generated specifically
// for NaturalOne-Chronicles via GPT Image 1. Each asset is rendered from a 90°
// overhead orthographic angle for true 2D battle-map use. Images are 256x256 PNGs
// stored at /map-assets-topdown/<key>.png.

const TD = (key) => `/map-assets-topdown/${key}.png`;

export const ASSET_CATEGORIES = [
  {
    key: "furniture",
    label: "Furniture",
    color: "#a78bfa",
    assets: [
      { key: "bed",            name: "Bed",            url: TD("bed") },
      { key: "table-round",    name: "Round Table",    url: TD("table-round") },
      { key: "table-long",     name: "Long Table",     url: TD("table-long") },
      { key: "chair",          name: "Chair",          url: TD("chair") },
      { key: "treasure-chest", name: "Treasure Chest", url: TD("treasure-chest") },
      { key: "bookshelf",      name: "Bookshelf",      url: TD("bookshelf") },
      { key: "fireplace",      name: "Fireplace",      url: TD("fireplace") },
      { key: "barrel",         name: "Barrel",         url: TD("barrel") },
      { key: "crate",          name: "Crate",          url: TD("crate") },
      { key: "rug",            name: "Rug",            url: TD("rug") },
    ],
  },
  {
    key: "camp",
    label: "Camp & Light",
    color: "#fb923c",
    assets: [
      { key: "tent",         name: "Tent",         url: TD("tent") },
      { key: "campfire",     name: "Campfire",     url: TD("campfire") },
      { key: "lantern",      name: "Lantern",      url: TD("lantern") },
      { key: "torch-sconce", name: "Torch Sconce", url: TD("torch-sconce") },
      { key: "bedroll",      name: "Bedroll",      url: TD("bedroll") },
    ],
  },
  {
    key: "nature",
    label: "Nature",
    color: "#4ade80",
    assets: [
      { key: "pine-tree",     name: "Pine Tree",     url: TD("pine-tree") },
      { key: "oak-tree",      name: "Oak Tree",      url: TD("oak-tree") },
      { key: "dead-tree",     name: "Dead Tree",     url: TD("dead-tree") },
      { key: "bush",          name: "Bush",          url: TD("bush") },
      { key: "rock-large",    name: "Boulder",       url: TD("rock-large") },
      { key: "rock-cluster",  name: "Rock Cluster",  url: TD("rock-cluster") },
      { key: "flowers",       name: "Wildflowers",   url: TD("flowers") },
      { key: "mushroom-ring", name: "Mushroom Ring", url: TD("mushroom-ring") },
      { key: "water-puddle",  name: "Water Puddle",  url: TD("water-puddle") },
      { key: "grass-patch",   name: "Grass Patch",   url: TD("grass-patch") },
    ],
  },
  {
    key: "dungeon",
    label: "Dungeon",
    color: "#94a3b8",
    assets: [
      { key: "skull-pile",  name: "Skull Pile",  url: TD("skull-pile") },
      { key: "sarcophagus", name: "Sarcophagus", url: TD("sarcophagus") },
      { key: "rubble",      name: "Rubble",      url: TD("rubble") },
      { key: "cobweb",      name: "Cobweb",      url: TD("cobweb") },
      { key: "blood-pool",  name: "Blood Pool",  url: TD("blood-pool") },
    ],
  },
  {
    key: "town",
    label: "Town",
    color: "#60a5fa",
    assets: [
      { key: "well",         name: "Well",         url: TD("well") },
      { key: "fountain",     name: "Fountain",     url: TD("fountain") },
      { key: "anvil",        name: "Anvil",        url: TD("anvil") },
      { key: "market-stall", name: "Market Stall", url: TD("market-stall") },
      { key: "wagon",        name: "Wagon",        url: TD("wagon") },
    ],
  },
  {
    key: "combat",
    label: "Combat",
    color: "#ef4444",
    assets: [
      { key: "weapon-rack",    name: "Weapon Rack",    url: TD("weapon-rack") },
      { key: "training-dummy", name: "Training Dummy", url: TD("training-dummy") },
    ],
  },
];

// Lookup by asset key (returns first match across categories)
export const findAsset = (assetKey) => {
  for (const cat of ASSET_CATEGORIES) {
    const a = cat.assets.find((x) => x.key === assetKey);
    if (a) return { ...a, category: cat.key, color: cat.color };
  }
  return null;
};
